export const META_PIXEL_ID = '1072392332244933'

type FbqFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[][]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: FbqFunction
    _fbq?: FbqFunction
  }
}

const SCRIPT_ID = 'meta-pixel-base-code'

/** Exact Meta Pixel base code, as supplied. */
const BASE_CODE = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${META_PIXEL_ID}');
fbq('track', 'PageView');`

const NOSCRIPT_HTML = `<img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1"
/>`

/** Installs the Meta Pixel base code inside <head>, once per page load. */
export function installMetaPixel(): void {
  if (typeof document === 'undefined') return
  if (document.getElementById(SCRIPT_ID)) return

  const head = document.head
  head.appendChild(document.createComment(' Meta Pixel Code '))

  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.text = BASE_CODE
  head.appendChild(script)

  const noscript = document.createElement('noscript')
  noscript.innerHTML = NOSCRIPT_HTML
  head.appendChild(noscript)

  head.appendChild(document.createComment(' End Meta Pixel Code '))
}
